import { Feature } from '../types/features.types.js'
import {
  dynamicContentTypes,
  staticContentTypes,
} from './contentTypes/contentTypes.js'

export const FeatureKey = {
  customerUserLogins: 'customerUserLogins',
  courses: 'courses',
  sponsors: 'sponsors',
  blog: 'blog',
  calendar: 'calendar',
  fontInterNunito: 'fontInterNunito',
  fontSofiaPro: 'fontSofiaPro',
  nav1: 'nav1',
  nav2: 'nav2',
  nav3: 'nav3',
  footer1: 'footer1',
  footer2: 'footer2',
  loadingAnimation: 'loadingAnimation',
  eCommerce: 'eCommerce',

  // Static components
  componentVideoHero: 'componentVideoHero',
  topSection: 'topSection',

  // Dynamic components
  grid: 'grid',
  header: 'header',
  richtext: 'richtext',
  button: 'button',
  image: 'image',
  contactform: 'contactform',
  quicklinks: 'quicklinks',
  accordion: 'accordion',
  tipsbox: 'tipsbox',
  document: 'document',
  ytvideo: 'ytvideo',
  imageCards: 'imageCards',
  bullets: 'bullets',
  imageCollage: 'imageCollage',
  logoSection: 'logoSection',
  serviceCard: 'serviceCard',
  form: 'form',
  gallery: 'gallery',
  dSolutionsBadge: 'dSolutionsBadge',
  foodMenu: 'foodMenu',
  openingHours: 'openingHours',
}

export const dynamicComponentFeatures: Feature[] = dynamicContentTypes.map(
  (contentType) => ({
    key: contentType.featureKey,
    name: `Component: ${contentType.viewName} (${contentType.name})`,
    default: contentType.default,
  })
)

export const staticComponentFeatures: Feature[] = staticContentTypes.map(
  (contentType) => ({
    key: contentType.featureKey,
    name: `Component: ${contentType.viewName} (${contentType.name})`,
    default: contentType.default,
  })
)

export const features: Feature[] = [
  ...staticComponentFeatures,
  ...dynamicComponentFeatures,
  {
    key: 'customerUserLogins',
    name: 'Customer user logins',
  },
  {
    key: 'courses',
    name: 'Courses',
  },
  {
    key: 'fontInterNunito',
    name: 'Font Inter/Nunito',
    default: true,
  },
  {
    key: 'fontSofiaPro',
    name: 'Font Sofia Pro',
  },
  {
    key: 'nav1',
    name: 'Nav 1 (Minimalistic)',
  },
  {
    key: 'nav2',
    name: 'Nav 2 (Basic)',
    default: true,
  },
  {
    key: 'nav3',
    name: 'Nav 3 (Enyoi)',
  },
  {
    key: 'footer1',
    name: 'Footer 1 (Basic)',
    default: true,
  },
  {
    key: 'footer2',
    name: 'Footer 2 (Enyoi)',
  },
  {
    key: 'eCommerce',
    name: 'eCommerce',
  },
]

export const defaultFeatures = features.filter((feature) => feature.default)
export const defaultFeatureKeys = defaultFeatures.map((feature) => feature.key)

export const featureKeys = features.reduce((acc, curr) => {
  acc[curr.key] = curr.key
  return acc
}, {} as { [key in keyof typeof FeatureKey]: keyof typeof FeatureKey })

export const getEnabledFeatures = (websiteFeatures: string[] = []) => {
  return features.filter((feature) => {
    return websiteFeatures.includes(feature.key)
  })
}
